import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { CustomImageRenderer } from './imageSourceRender';
export class UnchangingImageRenderer extends React.Component {
  constructor(_props) {
    super(_props);
    _defineProperty(this, "getCurrentImage", () => {
      const props = {
        ...this.props,
        ...this.state.current,
        key: 'pro-gallery-image-renderer-' + this.props.id
      };
      return /*#__PURE__*/React.createElement(CustomImageRenderer, props);
    });
    this.state = {
      current: {
        src: _props.src
      },
      latest: {
        src: _props.src
      },
      allowChanges: _props.allowChanges
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (JSON.stringify(this.props.src) !== JSON.stringify(nextProps.src)) {
      if (this.state.allowChanges !== false) {
        this.setState({
          current: {
            src: nextProps.src,
            priorityLoading: nextProps.priorityLoading
          },
          latest: {
            src: nextProps.src,
            priorityLoading: nextProps.priorityLoading
          }
        });
      } else {
        this.setState({
          latest: {
            src: nextProps.src,
            priorityLoading: nextProps.priorityLoading
          }
        });
      }
    }
    if (nextProps.allowChanges && nextProps.allowChanges !== this.state.allowChanges) {
      this.setState({
        allowChanges: true,
        current: {
          ...this.state.current,
          ...this.state.latest
        }
      });
    }
  }
  render() {
    return this.getCurrentImage();
  }
}
//# sourceMappingURL=UnchangingImageRenderer.js.map